import { Message } from '@cx/ui'
import { getSecurityGate } from '@/api/user'
import { SecurityGate } from '@/types'

const factorLabelMap: Record<string, string> = {
  phone: '手机号',
  email: '邮箱',
  wechat: '微信',
  password: '密码',
}

export type SecurityGateScene =
  | 'change_password'
  | 'change_phone'
  | 'change_email'
  | 'close_account'
  | 'api_token'
  | 'order_pay'
  | 'order_invoice'
  | 'order_contract'
  | 'admin_operation'

const getMissingFactorText = (result: SecurityGate) => {
  const missing = (result.missing_factors || []).map((item) => factorLabelMap[item] || item).join('、')
  return missing || '邮箱、微信或密码'
}

export const ensureSecurityGate = async (scene: SecurityGateScene) => {
  try {
    const result = await getSecurityGate(scene)
    if (result.pass) {
      return true
    }
    Message.warning(`账号安全等级较低，请先补充${getMissingFactorText(result)}后再继续`)
    return false
  } catch (error: any) {
    Message.error(error?.message || '安全校验失败，请稍后重试')
    return false
  }
}
